import { useTranslation } from 'react-i18next'
import { LuArrowLeft, LuX } from 'react-icons/lu'
import { Box, Flex } from '@chakra-ui/react'

import { FlowDirection, FlowStepDescription, PickUpAssetsStepData, StepType } from './models'

type Props = {
  flowStepIndex: number
  flowSteps: FlowStepDescription[]
  direction: FlowDirection
  goToPreviousStep: () => void
  onClose: () => void
}

const AsssetsManagementModalHeader = ({
  flowStepIndex,
  flowSteps,
  direction,
  goToPreviousStep,
  onClose,
}: Props): JSX.Element => {
  const { t } = useTranslation('common')

  const showBackArrow = (): boolean => {
    if (flowStepIndex === 0) {
      return false
    }

    const prevStep = flowSteps[flowStepIndex - 1]
    if (prevStep.type === StepType.PICKUP_ASSET && (prevStep.data as PickUpAssetsStepData).assets.length < 2) {
      return false
    }

    return true
  }

  return (
    <Flex direction="row" justifyContent="space-between" alignItems="center" width="100%">
      <Box as="span" lineHeight={1}>
        {direction === FlowDirection.PICKUP ? t('pickupAsset') : t('returnAsset')}
      </Box>
      <Flex gap={10} alignItems="center">
        {showBackArrow() && (
          <Box style={{ cursor: 'pointer' }} color="green.a200">
            <LuArrowLeft size={32} onClick={goToPreviousStep} />
          </Box>
        )}
        <Box style={{ cursor: 'pointer' }} onClick={onClose}>
          <LuX size={32} />
        </Box>
      </Flex>
    </Flex>
  )
}

export default AsssetsManagementModalHeader
